// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'expose-loader?jQuery!jquery' // eslint-disable-line
import 'expose-loader?$!jquery' // eslint-disable-line
import Vue from 'vue'
import Vuedals from 'vuedals'
import BootstrapVue from 'bootstrap-vue'
import VueTouch from 'vue-touch'
import Trend from 'vuetrend'
import {ServerTable} from 'vue-tables-2'
import Solr from './services/SolrHttp.js'
import Elastic from './services/ElasticHttp.js'
import Transparex from './services/TransparexHttp.js'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'

import store from './store'
import router from './Routes'
import App from './App'

Vue.use(require('vue-moment'))
Vue.use(BootstrapVue)
Vue.use(VueTouch)
Vue.use(Trend)
Vue.use(Vuedals)
Vue.use(ServerTable, {}, false, 'bootstrap3', 'default')

Vue.prototype.$solrHttp = Solr
Vue.prototype.$elasticHttp = Elastic
Vue.prototype.$transparexHttp = Transparex

var formatNumber = require('format-number')
var priceFormat = formatNumber({integerSeparator: ' ', decimalsSeparator: ' ', decimal: ','})
Vue.filter('formatPrice', function (value) {
  return priceFormat(value)
})
Vue.filter('filterDateTime', value => value ? format(parseISO(value), 'dd.MM.yyyy HH:mm') : '-')
Vue.filter('filterDate', value => value ? format(parseISO(value), 'dd.MM.yyyy') : '-')


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
})
